/* Towa : jauge de taille sur l'écran de résultat du guide (iframe srcdoc, même origine). */
(function () {
  'use strict';
  // Mêmes plages que towa-sizer.js : diamètre de l'index (mm) × π.
  var RANGES = [
    { key: 'S', min: 18.63 * Math.PI, max: 20.65 * Math.PI },
    { key: 'M', min: 20.65 * Math.PI, max: 22.71 * Math.PI },
    { key: 'L', min: 22.71 * Math.PI, max: 24.98 * Math.PI }
  ];
  // Libellé = ressenti du strap : doigt en bas de la plage → strap plus libre, en haut → plus serré.
  // Zone frontière (tour, mm) : entre deux tailles, on conseille la plus petite.
  var BORDER_MM = 1.0;
  // Marge d'incertitude affichée autour du repère (tour, mm).
  var BAND_MM = 1.0;

  var TXT = {
    fr: { title: 'Où tu te situes', snug: 'plus serré', ideal: 'idéal', loose: 'plus libre', between: 'Entre {a} et {b}',
          advice: 'Entre deux tailles, prends la plus petite : le strap se thermoforme et épouse la forme de ton doigt.' },
    en: { title: 'Where you sit', snug: 'snugger', ideal: 'ideal', loose: 'looser', between: 'Between {a} and {b}',
          advice: 'Between two sizes, go for the smaller one: the strap is heat-moulded and takes the shape of your finger.' },
    es: { title: 'Dónde te sitúas', snug: 'más ceñido', ideal: 'ideal', loose: 'más holgado', between: 'Entre {a} y {b}',
          advice: 'Entre dos tallas, elige la más pequeña: el strap se termoforma y se adapta a la forma de tu dedo.' }
  };

  function num(el) { return el ? parseFloat(String(el.textContent).replace(',', '.')) : NaN; }

  function analyse(c) {
    var lo = RANGES[0].min, hi = RANGES[RANGES.length - 1].max;
    if (!(c >= lo && c <= hi)) return null; // hors gamme : géré par towa-sizer.js
    var i = 0;
    while (i < RANGES.length - 1 && c >= RANGES[i].max) i++;
    var r = RANGES[i], res = { idx: i, between: null };
    if (i > 0 && c - r.min < BORDER_MM) {
      res.between = [RANGES[i - 1].key, r.key];
      res.idx = i - 1; // on conseille la plus petite
    } else if (i < RANGES.length - 1 && r.max - c < BORDER_MM) {
      res.between = [r.key, RANGES[i + 1].key];
    }
    res.t = (c - r.min) / (r.max - r.min);
    return res;
  }

  function gaugeHTML(doc, c, a) {
    var lang = (doc.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    var T = TXT[lang] || TXT.en;
    var lo = RANGES[0].min, hi = RANGES[RANGES.length - 1].max, span = hi - lo;
    var pct = function (v) { return Math.max(0, Math.min(100, (v - lo) / span * 100)); };
    var size = RANGES[a.idx].key;
    var label = a.between
      ? T.between.replace('{a}', a.between[0]).replace('{b}', a.between[1])
      : size + ' · ' + (a.t < 1 / 3 ? T.loose : a.t < 2 / 3 ? T.ideal : T.snug);

    var segs = RANGES.map(function (r) {
      var on = r.key === size;
      return '<div style="flex:' + (r.max - r.min).toFixed(3) + ';background:' + (on ? '#FF3D00' : '#34342f') + ';border-radius:3px"></div>';
    }).join('');
    var keys = RANGES.map(function (r) {
      var on = r.key === size;
      return '<div style="flex:' + (r.max - r.min).toFixed(3) + ';text-align:center;color:' + (on ? '#FF3D00' : '#77776d') + ';font-weight:' + (on ? '700' : '400') + '">' + r.key + '</div>';
    }).join('');
    var left = pct(c - BAND_MM), right = pct(c + BAND_MM);

    return '<div class="towa-gauge" style="margin:26px 0 0;text-align:left">' +
      '<div style="font-family:\'DM Mono\',monospace;font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#aaa9a0;margin-bottom:12px">' + T.title + '</div>' +
      '<div style="position:relative;height:12px;display:flex;gap:3px">' + segs +
        '<div aria-hidden="true" style="position:absolute;top:-6px;bottom:-6px;left:' + left.toFixed(2) + '%;width:' + Math.max(right - left, 1.5).toFixed(2) + '%;border:2px solid #F0EDE8;border-radius:5px;background:rgba(240,237,232,.18);box-sizing:border-box"></div>' +
      '</div>' +
      '<div style="display:flex;gap:3px;margin-top:10px;font-family:\'DM Mono\',monospace;font-size:13px">' + keys + '</div>' +
      '<div style="margin-top:16px;font-family:\'Barlow Condensed\',sans-serif;font-weight:700;font-size:22px;letter-spacing:.04em;text-transform:uppercase;color:#F0EDE8">' + label + '</div>' +
      (a.between ? '<p class="size-note" style="margin:6px 0 0">' + T.advice + '</p>' : '') +
      '</div>';
  }

  function enhance(doc) {
    var box = doc.getElementById('summaryBox');
    if (!box || box.querySelector('.towa-gauge')) return;
    var setResult = box.querySelector('.set-result');
    var sizeEl = setResult && setResult.querySelector('.set-size');
    var vals = box.querySelectorAll('.summary-item b');
    if (!sizeEl || vals.length < 3) return;
    var c = num(vals[vals.length - 1]);
    var a = analyse(c);
    if (!a) return;
    sizeEl.textContent = RANGES[a.idx].key;
    setResult.insertAdjacentHTML('beforeend', gaugeHTML(doc, c, a));
  }

  function attach(frame) {
    var doc;
    try { doc = frame.contentDocument; } catch (e) { return; }
    if (!doc) return;
    var box = doc.getElementById('summaryBox');
    if (!box) return;
    new MutationObserver(function () { enhance(doc); }).observe(box, { childList: true, subtree: true });
    enhance(doc);
  }

  function init() {
    var frames = document.querySelectorAll('.towa-sizer-page iframe');
    Array.prototype.forEach.call(frames, function (f) {
      f.addEventListener('load', function () { attach(f); });
      if (f.contentDocument && f.contentDocument.readyState === 'complete') attach(f);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
